import { render, staticRenderFns } from "./CompanyCampaign.vue?vue&type=template&id=6a85b5f3&scoped=true"
import script from "./CompanyCampaign.vue?vue&type=script&lang=js"
export * from "./CompanyCampaign.vue?vue&type=script&lang=js"
import style0 from "./CompanyCampaign.vue?vue&type=style&index=0&id=6a85b5f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85b5f3",
  null
  
)

export default component.exports